module.exports = {
    "checkbox": "checkbox",
    "checked": "checked"
}


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/CheckboxTemplate-style.js
 **/